import shallow from "zustand/shallow";

export const queryKeyEqual = (qkey1?: any[], qkey2?: any[]) => {
	if (qkey1?.length !== qkey2?.length) {
		return false;
	}
	return qkey1.every((part, i) => shallow(part, qkey2[i]));
};